import { FunctionComponent } from 'react'

import { Box } from 'native-base'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

type ContactIllustrationProps = {
  maxH?: number
}

export const ContactIllustration: FunctionComponent<ContactIllustrationProps> = ({
  maxH = 250
}) => (
  <Box {...{ maxH }}>
    <Svg width={247} height={250} viewBox="0 0 247 250" fill="none">
      <G clipPath="url(#clip0_8955_170057)">
        <Path
          d="M122.64 148.39H7.76961C4.9143 148.39 2.59961 150.704 2.59961 153.56V241.04C2.59961 243.895 4.9143 246.21 7.76961 246.21H122.64C125.495 246.21 127.81 243.895 127.81 241.04V153.56C127.81 150.704 125.495 148.39 122.64 148.39Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path d="M115.55 230.04H15.7695V233.96H115.55V230.04Z" fill="#404040" />
        <Path
          d="M127.81 222.999V240.779C127.81 241.489 127.67 242.199 127.4 242.859C127.13 243.519 126.73 244.119 126.22 244.619C125.72 245.129 125.12 245.529 124.46 245.799C123.8 246.069 123.09 246.209 122.38 246.209H8.03961C7.32961 246.209 6.61961 246.069 5.95961 245.799C5.29961 245.529 4.69961 245.129 4.18961 244.619C3.67961 244.119 3.27961 243.519 3.00961 242.859C2.73961 242.199 2.59961 241.489 2.59961 240.779V153.829C2.59961 153.119 2.73961 152.409 3.00961 151.749C3.27961 151.089 3.67961 150.489 4.18961 149.989C4.69961 149.479 5.28961 149.079 5.95961 148.809C6.61961 148.539 7.32961 148.399 8.03961 148.399H41.7396"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M15.7695 233.96H115.55V230.04H15.7695V233.96Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M45.6594 181.93H14.8594V217.81H45.6594V181.93Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.5994 160.56H14.8594V172.36H82.5994V160.56Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.5896 181.93H51.7896V217.81H82.5896V181.93Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M119.58 160.56H88.7798V217.81H119.58V160.56Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M73.54 112.089C64 116.999 55.91 124.319 50.06 133.309C44.21 142.299 40.8 152.669 40.18 163.379C39.55 174.089 41.73 184.779 46.49 194.389C51.25 204.009 58.44 212.209 67.34 218.199C76.24 224.189 86.55 227.759 97.25 228.549C107.95 229.339 118.67 227.329 128.36 222.719C138.05 218.109 146.37 211.049 152.49 202.249C158.62 193.439 162.35 183.189 163.31 172.509C167.83 124.119 116.7 89.7893 73.54 112.089Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M147.32 165.2C146.47 162.52 124.05 169.56 124.91 172.24C124.91 172.24 127.15 182.37 128.75 193.36C120.22 180.83 110.64 170.37 104.21 169.87C102.56 169.74 101.1 169.73 99.8901 169.57C99.1901 169.57 98.5001 169.38 97.8901 169.04C97.2801 168.7 96.7601 168.22 96.3801 167.63C95.3601 169.2 85.4501 169.62 84.3701 168.1C83.4701 169.08 82.2801 169.76 80.9801 170.04C76.6201 171.42 69.9401 171.49 65.6901 175.94L54.8701 187.2C58.0801 194.56 62.9701 201.06 69.1401 206.19L76.1101 199.15V211.02C86.9001 217.28 99.6201 219.36 111.85 216.87C112.54 215.1 113.12 213.39 113.64 211.71L117.28 215.44C125.21 212.87 132.4 208.4 138.2 202.4C144 196.41 148.25 189.09 150.57 181.07C149.77 175.73 148.69 170.43 147.33 165.2H147.32Z"
          fill="#F3123C"
        />
        <Path
          d="M65.6799 175.96C72.0299 169.31 83.7899 172.43 85.1899 166.41C87.0399 158.49 85.8199 152 84.5299 151.42C77.7398 148.41 80.3598 142.2 83.9798 144.82C85.7198 146.09 86.2698 145.81 86.3498 144.76V144.71C85.9098 138.78 90.8798 128.31 98.0299 141.09C89.0598 122.4 68.6799 134.05 70.8599 151.22C70.8599 151.22 50.8799 159.23 60.1799 181.67C61.9999 179.8 63.8199 177.89 65.6799 175.96Z"
          fill="#404040"
        />
        <Path
          d="M73.26 202.02C74.17 204.64 75.11 207.79 75.85 210.93L76.08 199.14L73.25 202.01L73.26 202.02Z"
          fill="#404040"
        />
        <Path
          d="M90.7898 157.09L94.6798 161.84C94.5798 160.65 94.5598 159.45 94.6198 158.25C93.2898 158.05 91.9998 157.66 90.7798 157.09H90.7898Z"
          fill="#404040"
        />
        <Path
          d="M122.92 185.46L130.12 205.25C129.82 201.5 129.32 197.44 128.77 193.52C126.87 190.7 124.88 188 122.92 185.46Z"
          fill="#404040"
        />
        <Path
          d="M69.1001 206.19L76.1401 199.18L76.0301 211.02"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M60.1801 181.68C58.3901 183.56 56.5901 185.41 54.8501 187.23"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M111.82 216.87C118.33 200.16 116.6 187.64 111.65 178.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M94.6301 158.239C94.5701 159.699 94.3801 165.229 96.7601 168.119C98.1901 169.859 100.73 169.639 104.24 169.889C110.74 170.379 120.17 180.899 128.77 193.629"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M144.48 164.7C142.6 155.29 141.77 152.79 139.93 144.99C139.69 143.97 139.38 142.75 138.96 141.37C137.44 136.27 135.72 136.04 136.31 142.09C136.53 144.38 136.5 146.68 136.2 148.96V149.02C136.12 149.77 135.99 150.52 135.81 151.26"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M136.2 149C135.29 146.18 134.24 143.41 133.05 140.69C131.01 135.61 128.88 135.47 130.29 141.71C131.76 148.22 131.23 151.34 131.23 151.34"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M127.72 152.75C127.72 152.75 123.65 141.57 123.36 140.88C121.15 135.64 123.05 134.67 125.9 139.06C128.49 143.06 131.28 148.5 131.28 148.5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M127.31 169.98C126.92 167.88 125.1 165.43 123.28 165.29C120.02 165.04 115.24 165.15 115.36 163.52C115.54 161.01 122.57 161.45 124.74 159.6C125.49 158.97 124.48 156.28 123.97 155.29C123.11 153.62 120.13 148.03 119.83 147.48C117.07 142.46 119.1 141.66 122.07 145.55C123.48 147.52 125.16 149.27 127.07 150.77"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M125.51 153.91C129.03 151.7 133.21 150.79 137.32 151.34"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M128.05 156.529C132.8 156.529 136.28 158.349 137.49 162.709"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M70.8599 151.23C70.8599 151.23 50.8799 159.24 60.1799 181.68C61.9999 179.8 63.8198 177.9 65.6698 175.97C72.0198 169.32 83.7799 172.44 85.1799 166.42C87.0299 158.5 85.8098 152.01 84.5198 151.43C77.7298 148.42 80.3499 142.21 83.9699 144.83C85.3799 145.86 86.4099 146.19 86.3299 144.44C86.0599 138.47 90.9898 128.53 98.0198 141.11C89.0498 122.42 68.6799 134.1 70.8599 151.24V151.23Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M70.8299 151.23C70.8299 151.23 61.1199 144.81 64.2599 142.26C67.3999 139.71 70.8299 151.23 70.8299 151.23Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M70.8301 151.23C70.8301 151.23 59.6001 154.38 59.7301 150.35C59.8701 146.35 70.8301 151.23 70.8301 151.23Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M113.62 211.71L117.26 215.44"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.2801 167.439C96.3601 169.339 84.6601 169.729 84.5801 167.799"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.48 169.48L88.17 177.76L92.97 168.87L102.99 175.96L97.58 168.84"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M92.9702 168.87C96.3902 174.03 104.62 189.35 99.5702 217.84"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M94.6798 161.83L90.8198 157.08C99.5998 161.16 106 155.07 98.0198 141.1"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M150.55 181.07C149.75 175.73 148.66 170.45 147.29 165.23C146.44 162.55 124.05 169.59 124.88 172.27C127.25 183.15 128.99 194.15 130.1 205.23L122.92 185.44"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M140.59 147.92H148.82"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M123.97 147.92H125.96"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.98 147.92H120.05"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M54.2998 147.92H70.6998"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M102.47 116C92.7099 115.83 83.1099 118.47 74.8099 123.6C66.5099 128.73 59.8499 136.14 55.6399 144.94C51.4199 153.74 49.8199 163.57 51.0299 173.25C52.2399 182.94 56.1999 192.07 62.4499 199.57C68.6999 207.07 76.9699 212.61 86.2699 215.55C95.5799 218.49 105.53 218.69 114.95 216.13C124.37 213.57 132.85 208.37 139.4 201.12C145.94 193.88 150.27 184.91 151.87 175.29C153.07 168.07 152.69 160.67 150.77 153.6C148.85 146.53 145.43 139.96 140.74 134.34C136.05 128.71 130.21 124.16 123.61 121C117.01 117.84 109.8 116.13 102.48 116H102.47Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M199.57 31.2297C199.18 29.1697 197.99 27.3497 196.26 26.1697C195.39 25.5697 194.41 25.1497 193.38 24.9297C192.35 24.7097 191.28 24.6997 190.24 24.8997C189.2 25.0997 188.22 25.4997 187.33 26.0797C186.45 26.6597 185.69 27.4097 185.11 28.2897L129.35 111.7C134.13 114.07 138.57 117.06 142.57 120.59L198.36 37.1497C199.53 35.4097 199.96 33.2797 199.57 31.2297Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M191.96 70.71C202.61 77.44 193.44 90.16 184.53 84.18C184.39 84.08 183.22 83.29 182.54 82.8C193.7 90.56 184.21 103.11 175.34 96.75L174.26 95.99C174.63 96.35 176.18 97.8 176.3 97.91C183.48 104.28 175.35 116.61 165.24 108.56C164.04 107.6 146.08 94.62 142.49 91.92L136 101.52C126.15 92.3 124.81 93.49 122.2 85.73C120.88 82.42 118.82 79.46 116.19 77.07C128.89 67.1 145.01 41.2 148.29 25.5C154.29 28.48 160.15 30.92 168.63 35.65C180.71 42.42 191.95 50.58 202.14 59.94C208.24 65.96 200.71 76.31 191.96 70.71Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M174.18 95.9098C171.31 93.7498 168.22 91.4198 165.73 89.5098"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.54 82.8102L173.71 76.1602"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M191.95 70.7194C188.61 68.2094 184.88 65.5894 182.15 63.6494"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M148.29 25.4995C148.29 25.4995 148.22 25.4595 148.18 25.4395"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M174.2 95.9399L174.18 95.9199"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M116.19 77.0702C116.15 77.0202 116.11 76.9902 116.07 76.9502"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.97 66.9702L1 15.9502"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M148.29 25.4997C145.01 41.1997 128.89 67.0997 116.19 77.0697C111.59 80.6697 107.44 82.1897 104.51 80.3797L82.9702 66.9697C96.0102 66.7097 134.84 7.30973 124.99 0.469727L146.08 13.7197C148.99 15.5097 149.48 19.8397 148.29 25.4997Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M81 66.4199C81.56 66.8099 82.23 66.9899 82.97 66.9699"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M246 97.44C246 98.01 245.83 98.58 245.51 99.05C245.19 99.53 244.74 99.9 244.21 100.12C243.68 100.34 243.1 100.4 242.53 100.29C241.96 100.18 241.45 99.9 241.04 99.5C240.63 99.09 240.36 98.58 240.24 98.01C240.13 97.45 240.19 96.86 240.41 96.33C240.63 95.8 241 95.35 241.48 95.03C241.96 94.71 242.52 94.54 243.09 94.54C243.47 94.54 243.85 94.61 244.2 94.76C244.55 94.91 244.87 95.12 245.14 95.39C245.41 95.66 245.62 95.98 245.77 96.33C245.91 96.68 245.99 97.06 245.99 97.44H246Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M151.16 249.45C151.16 249.77 151.06 250.09 150.89 250.36C150.71 250.63 150.46 250.84 150.16 250.96C149.86 251.08 149.54 251.11 149.22 251.05C148.9 250.99 148.61 250.83 148.39 250.61C148.16 250.38 148.01 250.09 147.94 249.78C147.88 249.46 147.91 249.14 148.03 248.84C148.15 248.54 148.36 248.29 148.63 248.11C148.9 247.93 149.21 247.83 149.53 247.83C149.74 247.83 149.96 247.87 150.15 247.95C150.35 248.03 150.53 248.15 150.68 248.3C150.83 248.45 150.95 248.63 151.03 248.83C151.11 249.03 151.15 249.24 151.15 249.46L151.16 249.45Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M230.75 140.55C230.9 140.95 231.17 141 231.54 141.04C232.14 141.06 232.7 141.31 233.12 141.74C233.53 142.17 233.77 142.74 233.77 143.34V144.92C233.77 145.22 233.71 145.52 233.59 145.8C233.47 146.08 233.3 146.34 233.09 146.55C232.88 146.77 232.62 146.94 232.34 147.05C232.06 147.17 231.76 147.23 231.46 147.22C231.31 147.22 231.16 147.26 231.03 147.35C230.9 147.44 230.81 147.56 230.75 147.7C230.71 147.8 230.67 147.91 230.62 148C230.43 148.43 230.26 148.81 230.63 149.18C230.85 149.4 231.02 149.65 231.13 149.93C231.25 150.21 231.31 150.51 231.31 150.81C231.31 151.11 231.25 151.41 231.13 151.69C231.01 151.97 230.84 152.22 230.63 152.44L229.53 153.56C229.32 153.78 229.06 153.95 228.78 154.06C228.5 154.18 228.2 154.24 227.9 154.24C227.6 154.24 227.3 154.18 227.02 154.06C226.74 153.94 226.48 153.77 226.27 153.56C226.16 153.45 226.02 153.37 225.87 153.35C225.72 153.32 225.56 153.35 225.42 153.41C225.32 153.45 225.23 153.49 225.13 153.53C224.7 153.69 224.3 153.85 224.3 154.37C224.3 154.67 224.24 154.97 224.12 155.26C224 155.54 223.83 155.79 223.62 156.01C223.41 156.23 223.15 156.4 222.87 156.51C222.59 156.63 222.29 156.69 221.99 156.68L220.39 156.7C220.09 156.7 219.79 156.64 219.51 156.52C219.23 156.41 218.97 156.24 218.76 156.02C218.55 155.81 218.38 155.55 218.26 155.27C218.14 154.99 218.08 154.69 218.09 154.39C218.09 154.24 218.05 154.09 217.96 153.96C217.87 153.83 217.75 153.73 217.61 153.68C217.51 153.64 217.42 153.6 217.33 153.56C216.91 153.37 216.52 153.19 216.15 153.56C215.94 153.78 215.68 153.95 215.4 154.06C215.12 154.18 214.82 154.24 214.52 154.24C214.22 154.24 213.92 154.18 213.64 154.06C213.36 153.94 213.1 153.77 212.89 153.56L211.77 152.44C211.55 152.22 211.38 151.97 211.27 151.69C211.15 151.41 211.1 151.11 211.1 150.81C211.1 150.51 211.16 150.21 211.27 149.93C211.39 149.65 211.56 149.4 211.77 149.18C211.88 149.07 211.96 148.93 211.99 148.78C212.02 148.63 211.99 148.47 211.93 148.33C211.89 148.23 211.85 148.14 211.81 148.04C211.64 147.61 211.49 147.21 210.97 147.21C210.67 147.21 210.37 147.15 210.09 147.04C209.81 146.93 209.55 146.76 209.34 146.54C209.13 146.33 208.96 146.07 208.84 145.79C208.72 145.51 208.66 145.21 208.67 144.91L208.65 143.33C208.65 143.03 208.71 142.73 208.82 142.45C208.93 142.17 209.11 141.91 209.32 141.7C209.53 141.48 209.79 141.31 210.07 141.2C210.35 141.08 210.65 141.02 210.95 141.03C211.1 141.03 211.25 140.99 211.38 140.9C211.51 140.81 211.61 140.69 211.66 140.55C211.7 140.45 211.74 140.34 211.79 140.25C211.98 139.82 212.15 139.44 211.78 139.07C211.56 138.86 211.4 138.6 211.28 138.32C211.16 138.04 211.1 137.74 211.1 137.44C211.1 137.14 211.16 136.84 211.28 136.56C211.4 136.28 211.57 136.03 211.78 135.81L212.92 134.69C213.13 134.48 213.39 134.3 213.67 134.19C213.95 134.08 214.25 134.01 214.55 134.01C214.85 134.01 215.15 134.07 215.43 134.19C215.71 134.31 215.97 134.48 216.18 134.69C216.28 134.8 216.42 134.87 216.57 134.9C216.72 134.93 216.87 134.91 217.01 134.85C217.11 134.81 217.2 134.77 217.3 134.73C217.73 134.56 218.13 134.41 218.13 133.89C218.13 133.59 218.19 133.29 218.3 133.01C218.41 132.73 218.58 132.47 218.8 132.26C219.01 132.04 219.27 131.87 219.55 131.76C219.83 131.64 220.13 131.58 220.43 131.59H222.01C222.31 131.59 222.61 131.65 222.89 131.76C223.17 131.88 223.43 132.05 223.64 132.26C223.85 132.47 224.02 132.73 224.14 133.01C224.26 133.29 224.32 133.59 224.32 133.89C224.32 134.04 224.36 134.19 224.45 134.32C224.53 134.45 224.66 134.54 224.8 134.6C224.9 134.64 224.99 134.68 225.08 134.72C225.5 134.91 225.89 135.09 226.26 134.72C226.69 134.29 227.28 134.04 227.89 134.04C228.5 134.04 229.09 134.28 229.52 134.72L230.64 135.82C230.85 136.03 231.02 136.29 231.14 136.57C231.26 136.85 231.32 137.15 231.32 137.45C231.32 137.75 231.26 138.05 231.14 138.33C231.02 138.61 230.85 138.86 230.64 139.08C230.27 139.47 230.44 139.84 230.62 140.26C230.67 140.36 230.71 140.46 230.75 140.57V140.55ZM217.92 149.02C218.89 149.67 220.03 150.01 221.2 150.01C221.98 150.01 222.74 149.86 223.46 149.57C224.18 149.27 224.83 148.84 225.38 148.29C225.93 147.74 226.36 147.09 226.66 146.37C226.95 145.65 227.11 144.88 227.1 144.11C227.1 142.94 226.75 141.8 226.11 140.84C225.46 139.87 224.54 139.11 223.46 138.67C222.38 138.22 221.2 138.11 220.05 138.33C218.91 138.56 217.86 139.12 217.03 139.94C216.21 140.76 215.64 141.81 215.42 142.96C215.19 144.11 215.31 145.29 215.76 146.37C216.21 147.45 216.96 148.37 217.93 149.02H217.92Z"
          fill="#F3123C"
        />
        <Path
          d="M231.54 141.04C231.18 141 230.9 140.96 230.75 140.55C230.54 140 230.18 139.54 230.63 139.06C230.84 138.84 231.01 138.59 231.13 138.31C231.25 138.03 231.31 137.73 231.31 137.43C231.31 137.13 231.25 136.83 231.13 136.55C231.01 136.27 230.84 136.02 230.63 135.8L229.51 134.7C229.08 134.27 228.49 134.02 227.88 134.02C227.27 134.02 226.68 134.26 226.25 134.7C225.79 135.16 225.31 134.79 224.79 134.59C224.65 134.53 224.52 134.44 224.44 134.31C224.35 134.18 224.31 134.03 224.31 133.88C224.31 133.58 224.25 133.28 224.13 133C224.01 132.72 223.84 132.46 223.63 132.25C223.42 132.04 223.16 131.87 222.88 131.75C222.6 131.63 222.3 131.58 222 131.58H220.42C220.12 131.58 219.82 131.64 219.54 131.75C219.26 131.86 219 132.03 218.79 132.25C218.57 132.46 218.4 132.72 218.29 133C218.17 133.28 218.11 133.58 218.12 133.88C218.12 134.52 217.53 134.61 217 134.84C216.86 134.9 216.71 134.92 216.56 134.89C216.41 134.86 216.28 134.79 216.17 134.68C215.96 134.47 215.7 134.29 215.42 134.18C215.14 134.07 214.84 134 214.54 134C214.24 134 213.94 134.06 213.66 134.18C213.38 134.3 213.12 134.47 212.91 134.68L211.77 135.8C211.55 136.01 211.39 136.27 211.27 136.55C211.15 136.83 211.09 137.13 211.09 137.43C211.09 137.73 211.15 138.03 211.27 138.31C211.39 138.59 211.56 138.85 211.77 139.06C212.23 139.52 211.86 140 211.65 140.55C211.6 140.69 211.5 140.82 211.37 140.9C211.24 140.99 211.09 141.03 210.94 141.03C210.64 141.03 210.34 141.09 210.06 141.2C209.78 141.32 209.52 141.49 209.31 141.7C209.1 141.91 208.92 142.17 208.81 142.45C208.69 142.73 208.63 143.03 208.64 143.33L208.66 144.91C208.66 145.21 208.72 145.51 208.83 145.79C208.95 146.07 209.12 146.32 209.33 146.54C209.54 146.76 209.8 146.93 210.08 147.04C210.36 147.16 210.66 147.22 210.96 147.21C211.6 147.21 211.69 147.81 211.92 148.33C211.99 148.47 212.01 148.63 211.98 148.78C211.95 148.93 211.88 149.07 211.76 149.18C211.54 149.4 211.37 149.65 211.26 149.93C211.14 150.21 211.09 150.51 211.09 150.81C211.09 151.11 211.15 151.41 211.26 151.69C211.38 151.97 211.55 152.22 211.76 152.44L212.88 153.56C213.09 153.78 213.35 153.95 213.63 154.06C213.91 154.18 214.21 154.24 214.51 154.24C214.81 154.24 215.11 154.18 215.39 154.06C215.67 153.94 215.92 153.77 216.14 153.56C216.6 153.1 217.08 153.47 217.6 153.68C217.74 153.73 217.87 153.83 217.95 153.96C218.04 154.09 218.08 154.24 218.08 154.39C218.08 154.69 218.14 154.99 218.25 155.27C218.37 155.55 218.54 155.81 218.75 156.02C218.96 156.24 219.22 156.41 219.5 156.52C219.78 156.64 220.08 156.7 220.38 156.7L221.98 156.68C222.28 156.68 222.58 156.62 222.86 156.51C223.14 156.4 223.4 156.23 223.61 156.01C223.82 155.8 223.99 155.54 224.11 155.26C224.23 154.98 224.29 154.68 224.29 154.37C224.29 153.73 224.88 153.64 225.41 153.41C225.55 153.35 225.71 153.33 225.86 153.35C226.01 153.38 226.15 153.45 226.26 153.56C226.47 153.78 226.73 153.95 227.01 154.06C227.29 154.18 227.59 154.24 227.89 154.24C228.19 154.24 228.49 154.18 228.77 154.06C229.05 153.94 229.3 153.77 229.52 153.56L230.62 152.44C230.84 152.22 231.01 151.97 231.12 151.69C231.24 151.41 231.3 151.11 231.3 150.81C231.3 150.51 231.24 150.21 231.12 149.93C231 149.65 230.83 149.4 230.62 149.18C230.16 148.72 230.53 148.24 230.74 147.69C230.79 147.55 230.89 147.42 231.02 147.34C231.15 147.26 231.3 147.21 231.45 147.21C231.75 147.21 232.05 147.15 232.33 147.04C232.61 146.93 232.87 146.76 233.08 146.54C233.29 146.33 233.46 146.07 233.58 145.79C233.7 145.51 233.76 145.21 233.76 144.91V143.33C233.76 142.73 233.53 142.16 233.11 141.73C232.69 141.3 232.13 141.05 231.53 141.03L231.54 141.04Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M221.2 150.01C220.03 150.01 218.9 149.66 217.92 149.02C216.95 148.37 216.2 147.45 215.75 146.37C215.3 145.29 215.19 144.11 215.41 142.96C215.64 141.82 216.2 140.77 217.02 139.94C217.84 139.12 218.89 138.55 220.04 138.33C221.18 138.1 222.37 138.22 223.45 138.67C224.53 139.12 225.45 139.87 226.1 140.84C226.75 141.81 227.09 142.95 227.09 144.11C227.09 144.88 226.94 145.65 226.65 146.37C226.35 147.09 225.92 147.74 225.37 148.29C224.82 148.84 224.17 149.27 223.45 149.57C222.73 149.86 221.96 150.02 221.19 150.01H221.2Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.62 144.14H193.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.62 189.44H193.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.62 224.46H193.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M16.5098 72.54V103.56"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M32.03 88.0596H1"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M212.71 218.3C214.97 216.06 218.02 214.81 221.2 214.82C224.38 214.82 227.43 216.06 229.69 218.3C231.95 220.54 233.22 223.58 233.24 226.76C233.22 228.92 232.62 231.05 231.5 232.9C230.38 234.75 228.78 236.27 226.87 237.29C224.96 238.31 222.81 238.8 220.65 238.7C218.49 238.6 216.39 237.92 214.58 236.74L209.95 238.21L211.45 233.77C209.96 231.74 209.15 229.28 209.16 226.76C209.18 223.58 210.45 220.54 212.71 218.3V218.3Z"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M228.96 230.181C228.87 230.041 228.64 229.951 228.29 229.771C227.94 229.601 226.21 228.751 225.89 228.641C225.57 228.521 225.33 228.461 225.1 228.811C224.87 229.161 224.19 229.941 223.99 230.171C223.78 230.401 223.58 230.431 223.23 230.261C222.2 229.851 221.24 229.271 220.4 228.531C219.63 227.831 218.97 227.021 218.45 226.121C218.24 225.771 218.43 225.581 218.6 225.411C218.97 225.081 219.27 224.671 219.48 224.221C219.53 224.121 219.55 224.021 219.54 223.911C219.54 223.801 219.5 223.701 219.45 223.611C219.36 223.441 218.66 221.721 218.37 221.031C218.04 220.241 216.56 220.211 215.97 220.851C214.1 222.881 214.53 225.181 216.18 227.361C216.36 227.591 218.61 231.231 222.18 232.621C225.75 234.021 225.75 233.551 226.39 233.491C228.24 233.321 229.49 231.061 228.96 230.181Z"
          fill="#F3123C"
        />
        <Path
          d="M228.96 230.181C228.87 230.041 228.64 229.951 228.29 229.771C227.94 229.601 226.21 228.751 225.89 228.641C225.57 228.521 225.33 228.461 225.1 228.811C224.87 229.161 224.19 229.941 223.99 230.171C223.78 230.401 223.58 230.431 223.23 230.261C222.2 229.851 221.24 229.271 220.4 228.531C219.63 227.831 218.97 227.021 218.45 226.121C218.24 225.771 218.43 225.581 218.6 225.411C218.97 225.081 219.27 224.671 219.48 224.221C219.53 224.121 219.55 224.021 219.54 223.911C219.54 223.801 219.5 223.701 219.45 223.611C219.36 223.441 218.66 221.721 218.37 221.031C218.04 220.241 216.56 220.211 215.97 220.851C214.1 222.881 214.53 225.181 216.18 227.361C216.36 227.591 218.61 231.231 222.18 232.621C225.75 234.021 225.75 233.551 226.39 233.491C228.24 233.321 229.49 231.061 228.96 230.181"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M229.23 187.77L235.51 184.42C237.32 186.61 235.97 188.44 235.15 188.82L231.91 190.44L235.15 188.82C235.15 188.82 237.6 191.95 231.91 194.46"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M213.16 187.77L206.88 184.42C205.13 186.61 206.46 188.41 207.24 188.82L210.48 190.44L207.24 188.82C207.24 188.82 204.79 191.95 210.48 194.46"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M227.89 184.43H214.5C213.76 184.43 213.16 185.03 213.16 185.77V195.14C213.16 195.88 213.76 196.48 214.5 196.48H227.89C228.63 196.48 229.23 195.88 229.23 195.14V185.77C229.23 185.03 228.63 184.43 227.89 184.43Z"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M213.62 184.76L220.39 189.85C220.62 190.02 220.9 190.12 221.19 190.12C221.48 190.12 221.76 190.03 221.99 189.85L228.76 184.76"
          fill="#F3123C"
        />
        <Path
          d="M213.62 184.76L220.39 189.85C220.62 190.02 220.9 190.12 221.19 190.12C221.48 190.12 221.76 190.03 221.99 189.85L228.76 184.76"
          stroke="#2E2E2E"
          strokeWidth={1.29}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8955_170057">
          <Rect width={245.94} height={251.55} fill="white" transform="translate(0.529785)" />
        </ClipPath>
      </Defs>
    </Svg>
  </Box>
)
